import { Control, FieldErrors, useWatch } from 'react-hook-form'

import { ChildProps } from '@/common/util/props'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import ModalContent from '@/components/view/layouts/modal/ModalContent'
import ModalFooter from '@/components/view/molecules/modal/ModalFooter'

import {
  CsvUploadFormSchemaType,
  CsvUploadMode,
  CsvUploadResult
} from '@/components/container/form/modules/master/csvUpload/csvUploadSchema'
import CsvUploadResultContent from '@/components/container/form/widgets/csv/CsvUploadResultContent'

interface Props extends ChildProps {
  result: CsvUploadResult
  reset: () => void
  onClickClose(): void
  control: Control<CsvUploadFormSchemaType>
  errors: FieldErrors<CsvUploadFormSchemaType>
}

const CsvUploadFormContent = ({ children, result, reset, onClickClose, control }: Props) => {
  const csv = useWatch({ control, name: 'csv' })

  return (
    <>
      {result.mode == CsvUploadMode.FORM && (
        <>
          <ModalContent>{children}</ModalContent>
          <ModalFooter>
            <Button
              color={'secondary'}
              size={'large'}
              onClick={() => {
                onClickClose()
                reset()
              }}
            >
              キャンセル
            </Button>
            <Button
              color={ButtonColor.PRIMARY_BRAND}
              size={'large'}
              disabled={!csv}
              type={'submit'}
            >
              アップロード
            </Button>
          </ModalFooter>
        </>
      )}
      {result.mode == CsvUploadMode.RESULT && (
        <CsvUploadResultContent
          result={result}
          onClickRedo={() => {
            reset()
          }}
          onClickClose={() => {
            reset()
            onClickClose()
          }}
        />
      )}
    </>
  )
}

export default CsvUploadFormContent
